import About from "./About"
import Hero from "../components/home/hero/Hero"
import AdvertCardListThree from "../components/AdvertCard/AdvertCard"
import HomeListingsByType from "../components/home/HomeListingsByType"
import VideoHome from "../components/VideoHome/VideoHome"
import Whatsapp1 from "../components/Whatsapp1/Whatsapp1"
import Call1 from "../components/Call1/Call1"

const Home = () => {
  return (
    <>
      <Hero />
      <Call1 />
      <Whatsapp1 />
      <AdvertCardListThree />
      <About />
      <VideoHome />
      <HomeListingsByType />
    
      
     
    </>
  )
}

export default Home
